import mutations from './vaccinationReport.mutations'
import actions from './vaccinationReport.actions'
import getters from './vaccinationReport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
